import ArrayIterator from "/lib/html5-software-library/src/ranj/util/datastructures/array/ArrayIterator";

/**
* ScenarioLibrary.js
* 
* Created on 8-okt-2013, 11:55:31
*
* @author Ivo Swartjes for Ranj
**/
export default class ScenarioLibrary {
	constructor() {
        this._scenarios = [];
        this._currentScenario;
        this._defaultScenario;
    };
    
    getCurrentScenario() {
        return this._currentScenario;
    };
    
    setCurrentScenario(scenario) {
        this._currentScenario = scenario;
    };
    
    getDefaultScenario() {
        return this._defaultScenario;
    };
    
    setDefaultScenario(scenario) {
        this._defaultScenario = scenario;
    };
    
    addScenario(scenario) {
        this._scenarios.push(scenario);
    };
    
    getScenarioByID(id) {
        for (var i = 0; i < this._scenarios.length; i++) {
            var scenario = this._scenarios[i];
            if (scenario.id === id) {
                return scenario;
            }
        }
        
        return null;
    };
    
    scenarioIterator() {
        return new ArrayIterator(this._scenarios);
    };

}


